import {Component, Inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild, DOCUMENT} from '@angular/core';
import RemoteFileSystemProvider from 'devextreme/file_management/remote_provider';
import {environment} from '../environments/environment';

import {GenericService} from '../common/common.service';
import {DashboardappComponent} from '../DashBoardManagement/dashboardapp/dashboardapp.component';
import {UtilityService} from '../common/utility.service';
import {FileSystemConfiguration} from "./FIleManager.model";
import {DxFileManagerComponent} from "devextreme-angular";

@Component({
    selector: 'FileManager',
    templateUrl: './FileManager.component.html',
    styleUrls: ['./FileManager.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})

export class FileManager implements OnInit, OnChanges {
  @ViewChild(DxFileManagerComponent) __oFileManager : DxFileManagerComponent;
  @Input() FileSystem: string;
  @Input() Directory: string;
  @Input() __bMenuVisible: boolean = true;

  public __oFileSystemProvider: RemoteFileSystemProvider;
  public __oFileSystemConfiguration: FileSystemConfiguration;
  public __sSelectedDirectory: string; 
  constructor(
    @Inject(DOCUMENT) private document: any,
    public service: GenericService,
    private dashboardappComponent: DashboardappComponent,
    public __oUtilityService: UtilityService
  ) {
  }

  ngOnInit() {
    this.getFileSystemConfiguration(this.FileSystem);
    this.buildRemoteFileSystem();
  }
  ngOnChanges(changes:SimpleChanges){
    if(this.__oFileManager){
      this.Directory = changes.Directory.currentValue;
      this.buildRemoteFileSystem();
      //this.__oFileManager?.instance?.refresh().then((data)=>{},(error)=>{})
    }
  }
  buildRemoteFileSystem(){
    this.__oFileSystemProvider = new RemoteFileSystemProvider({
      endpointUrl: this.getFileSystemUrl(),
      beforeAjaxSend: function ({ headers, formData, xhrFields }) {
        xhrFields.withCredentials = true;
      },
      requestHeaders: {
        Directory: this.Directory.trim()
      }      
    });
  }
  getFileSystemConfiguration(sFileSystemConfigurationName:string):void{
    this.service.getDataByPromise(this.__oUtilityService.GetBasewebAPIURL()+ "api/FileManager/GetFileSystemConfiguration/"+ sFileSystemConfigurationName).then(
        (data) => {
          this.__oFileSystemConfiguration = data;
        },
        (error) => {
          this.__oFileSystemConfiguration = null;
        }
      );
  }
  getFileSystemUrl() {
    return this.__oUtilityService.GetBasewebAPIURL() + 'api/FileManager/' + encodeURIComponent(this.FileSystem.trim()) + '/';
  }


  customizeIcon(fileSystemItem) {
    if (fileSystemItem.isDirectory) {
      return 'folder';
    }
    return 'file';
  }

  onDirectoryChanged(e: any) {
    this.__sSelectedDirectory = e.directory.path;
  }

}
